import { render } from "./InfoAveragePriceAmount.vue?vue&type=template&id=d653f990"
import script from "./InfoAveragePriceAmount.vue?vue&type=script&lang=js"
export * from "./InfoAveragePriceAmount.vue?vue&type=script&lang=js"

import "./InfoAveragePriceAmount.vue?vue&type=style&index=0&id=d653f990&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__